import React, {useState} from 'react'
import classNames from "classnames";
import {useDispatch, useSelector} from "react-redux";
import ChatView from "./chat_view";
import _ from "lodash";
import moment from "moment-timezone";
import ChatPreview from "./chat_preview";
import AccountSettings from "./account_settings";

export default function SupportChat() {
  const account = useSelector((state) => state.account)
  const selectedSupportChatSessionId = useSelector((state) => state.selectedSupportChatSessionId)
  const supportChatSessions = useSelector((state) => state.supportChatSessions)
  const supportChatMessages = useSelector(state => state.supportChatMessages)

  const selectedSupportChatSession = supportChatSessions.filter((supportChatSession) => supportChatSession.id === selectedSupportChatSessionId)[0]

  const archivedSupportChatSessions = _.orderBy(supportChatSessions.filter((supportChatSession) => supportChatSession.complete),
    (supportChatSession) => [moment(supportChatSession.created_at).valueOf()], ['desc'])
  const unansweredSupportChatSessions = _.orderBy(supportChatSessions.filter((supportChatSession) => !supportChatSession.complete && !supportChatSession.assigned_account_id),
    (supportChatSession) => [moment(supportChatSession.created_at).valueOf()], ['desc'])
  const handledByOthersSupportChatSessions = _.orderBy(supportChatSessions.filter((supportChatSession) => !supportChatSession.complete && !!supportChatSession.assigned_account_id && supportChatSession.assigned_account_id != account.id),
    (supportChatSession) => [moment(supportChatSession.created_at).valueOf()], ['desc'])
  const yourSupportChatSessions = _.orderBy(supportChatSessions.filter((supportChatSession) => !supportChatSession.complete && supportChatSession.assigned_account_id === account.id),
    (supportChatSession) => {
      const messages = supportChatMessages.filter(scm => scm.support_chat_session_id === supportChatSession.id)
      const last_change_at = moment((_.orderBy(messages, (support_chat_message) => [moment(support_chat_message.created_at).valueOf()], ['desc'])[0] || supportChatSession).created_at).valueOf()
      return [last_change_at]
    }, ['desc'])

  const [selectedTab, setSelectedTab] = useState("chats")

  return <div className="row no-gutters">
    <div className="col-3">
      <AccountSettings/>
      <ul className="nav nav-tabs nav-justified">
        <li className="nav-item">
          <div
            className={classNames("nav-link", {"active": selectedTab === "chats"})}
            onClick={() => setSelectedTab("chats")}
          >
            Chats
          </div>
        </li>
        <li className="nav-item">
          <div
            className={classNames("nav-link", {"active": selectedTab === "others"})}
            onClick={() => setSelectedTab("others")}
          >
            Others
          </div>
        </li>
        <li className="nav-item">
          <div
            className={classNames("nav-link", {"active": selectedTab === "archived"})}
            onClick={() => setSelectedTab("archived")}
          >
            Archived
          </div>
        </li>
      </ul>

      {selectedTab === "chats" && <div className="row">
        <div className="col-12">

          {((!yourSupportChatSessions || yourSupportChatSessions.length < 1)&&
          (!unansweredSupportChatSessions || unansweredSupportChatSessions.length < 1)&&
          (!handledByOthersSupportChatSessions || handledByOthersSupportChatSessions.length < 1)) && <div className={"row"}>
            <div className="col-12 pt-4 text-center">
              <h5>Currently there are no chats</h5>
              <p>Wait until a customer contacts you.</p>
            </div>
          </div>}

          {yourSupportChatSessions && yourSupportChatSessions.length > 0 && <>
            <h5>Your chats</h5>
            <div className="list-group">
              {yourSupportChatSessions.map(supportChatSession => {
                return <ChatPreview key={supportChatSession.id} supportChatSession={supportChatSession} />
              })}
            </div>
          </>}
          {unansweredSupportChatSessions && unansweredSupportChatSessions.length > 0 && <>
          <h5>Unanswered chats</h5>
          <div className="list-group">
            {unansweredSupportChatSessions.map(supportChatSession => {
              return <ChatPreview key={supportChatSession.id} supportChatSession={supportChatSession} />
            })}
          </div>
          </>}
        </div>
      </div>}

      {selectedTab === "others" && <div className="row">
        <div className="col-12">
          <div className="list-group">
            {handledByOthersSupportChatSessions.map(supportChatSession => {
              return <ChatPreview key={supportChatSession.id} supportChatSession={supportChatSession} />
            })}
          </div>
        </div>
      </div>}

      {selectedTab === "archived" && <div className="row">
        <div className="col-12">
          <div className="list-group">
            {archivedSupportChatSessions.map(supportChatSession => {
              return <ChatPreview key={supportChatSession.id} supportChatSession={supportChatSession} />
            })}
          </div>
        </div>
      </div>}

    </div>
    <div className="col-9 border">
      {selectedSupportChatSession ? <ChatView supportChatSession={selectedSupportChatSession}/> : <div className={"row"}>
        <div className="col-12 text-center mt-5">
          <h3>No Chat Selected</h3>
          <p>Select a chat on the left hand side.</p>
        </div>
      </div>}
    </div>
  </div>
}